<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="toctitle"><i>Contents</i></h2>
<p class="toc"><a href="#/preface">PREFACE</a></p>
<p class="toc"><a href="#/guide">USING THE GUIDE</a></p>
<p class="toc"><a href="#/abbreviations">ABBREVIATIONS</a></p>
<p class="toc"><a href="#/publish">AMERICAN AGENTS, DISTRIBUTORS, OR PARENT COMPANIES OF MUSIC PUBLISHERS</a></p>
<p class="toc"><a href="#/address">ADDRESSES OF MUSIC PUBLISHERS</a></p>
<p class="toc1"><a href="#/part1"><span class="small">PART I</span>: <i>Individual Composers: Their Solo Piano Works in Various Editions and Facsimile Reproductions</i></a></p>
<p class="toc1"><span href="#/part2" title="Link target outside of Sample"><span class="small">PART II</span>: <i>Anthologies and Collections</i></span></p>
<p class="toc2"><span href="#/part2#sub1" title="Link target outside of Sample">Collections Spanning Historical Periods</span></p>
<p class="toc2"><span href="#/part2#sub2" title="Link target outside of Sample">Baroque</span></p>
<p class="toc2"><span href="#/part2#sub3" title="Link target outside of Sample">Classical Period</span></p>
<p class="toc2"><span href="#/part2#sub4" title="Link target outside of Sample">Nineteenth-Century Romanticism</span></p>
<p class="toc2"><span href="#/part2#sub5" title="Link target outside of Sample">Twentieth Century to 2010</span></p>
<p class="toc2"><span href="#/part2#sub6" title="Link target outside of Sample">Tombeaux, Hommages</span></p>
<p class="toc2"><span href="#/part2#sub7" title="Link target outside of Sample">African</span></p>
<p class="toc2"><span href="#/part2#sub8" title="Link target outside of Sample">American</span></p>
<p class="toc2"><span href="#/part2#sub9" title="Link target outside of Sample">Australian</span></p>
<p class="toc2"><span href="#/part2#sub10" title="Link target outside of Sample">Austrian</span></p>
<p class="toc2"><span href="#/part2#sub11" title="Link target outside of Sample">Belgian</span></p>
<p class="toc2"><span href="#/part2#sub12" title="Link target outside of Sample">Brazilian</span></p>
<p class="toc2"><span href="#/part2#sub13" title="Link target outside of Sample">Bulgarian</span></p>
<p class="toc2"><span href="#/part2#sub14" title="Link target outside of Sample">Canadian</span></p>
<p class="toc2"><a href="#/part201#sub15">Chinese</a></p>
<p class="toc2"><a href="#/part201#sub16">Czech</a></p>
<p class="toc2"><a href="#/part201#sub17">Dutch</a></p>
<p class="toc2"><a href="#/part201#sub18">English</a></p>
<p class="toc2"><a href="#/part201#sub19">English Virginalists</a></p>
<p class="toc2"><a href="#/part201#sub20">Finnish</a></p>
<p class="toc2"><a href="#/part201#sub21">French</a></p>
<p class="toc2"><a href="#/part201#sub22">French Clavecinists</a></p>
<p class="toc2"><a href="#/part201#sub23">German</a></p>
<p class="toc2"><a href="#/part201#sub24">German: Bach Family</a></p>
<p class="toc2"><a href="#/part201#sub25">Greek</a></p>
<p class="toc2"><a href="#/part201#sub26">Hungarian</a></p>
<p class="toc2"><a href="#/part201#sub27">Irish</a></p>
<p class="toc2"><a href="#/part201#sub28">Israeli</a></p>
<p class="toc2"><a href="#/part201#sub29">Italian</a></p>
<p class="toc2"><a href="#/part201#sub30">Japanese</a></p>
<p class="toc2"><a href="#/part201#sub31">Latin American</a></p>
<p class="toc2"><a href="#/part201#sub32">New Zealand</a></p>
<p class="toc2"><a href="#/part201#sub33">Polish</a></p>
<p class="toc2"><a href="#/part201#sub34">Portuguese</a></p>
<p class="toc2"><a href="#/part201#sub35">Romanian</a></p>
<p class="toc2"><a href="#/part201#sub36">Russian</a></p>
<p class="toc2"><a href="#/part201#sub37">Scandinavian</a></p>
<p class="toc2"><a href="#/part201#sub38">Scottish</a></p>
<p class="toc2"><a href="#/part201#sub39">Slovakian</a></p>
<p class="toc2"><a href="#/part201#sub40">Spanish</a></p>
<p class="toc2"><a href="#/part201#sub41">Swiss</a></p>
<p class="toc2"><a href="#/part201#sub42">Yugoslavian</a></p>
<p class="indent"> </p>
<p class="toc"><span href="#/bib" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
<p class="indent"> </p>
<p class="toc"><span href="#/app" title="Link target outside of Sample">APPENDIX: <i>Historical Recital Programs</i></span></p>
<p class="toc2"><span href="#/app#sub1" title="Link target outside of Sample">Anton Rubinstein, 1885–1886</span></p>
<p class="toc2"><span href="#/app#sub2" title="Link target outside of Sample">Ferruccio Busoni, 1911</span></p>
<p class="toc2"><span href="#/app#sub3" title="Link target outside of Sample">Ossip Gabrilowitsch, 1915–1916</span></p>
<p class="indent"> </p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">INDEXES:</span></p>
<p class="toc2"><span href="#/index#sub1" title="Link target outside of Sample">Alphabetical List of Composers under Nationality Designations</span></p>
<p class="toc2"><span href="#/index#sub2" title="Link target outside of Sample">Compositions for Piano and Live or Recorded Electronics</span></p>
<p class="toc2"><span href="#/index#sub3" title="Link target outside of Sample">Compositions for Prepared Piano</span></p>
<p class="toc2"><span href="#/index#sub4" title="Link target outside of Sample">Title Index to Anthologies and Collections</span></p>
<p class="toc3"><span href="#/index#sub5" title="Link target outside of Sample">Title Index to <i>Anatomy of a Classic, Virtuoso</i> Series, and Van Cliburn Competition–Commissioned Works and Publishers</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?28af2954